module.exports = __webpack_public_path__ + "img/mycx.527735c6.jpg";